import { DefaultValue, selector } from 'recoil';
import { createFieldSelector } from '@zurich/common/recoil';
import { localDocumentMetadataAtom } from '../atoms';
export const localPartyDocumentMetadataHelper = createFieldSelector(localDocumentMetadataAtom);
export const localPartyDocumentMetadataDocSubTypeSelector = localPartyDocumentMetadataHelper('docSubType', {
    defaultValue: undefined,
});
export const localPartyDocumentMetadataDriversLicenseNumberSelector = localPartyDocumentMetadataHelper('driversLicenseNumber', {
    defaultValue: undefined,
});
export const localPartyDocumentMetadataIdentityDocumentNumberSelector = localPartyDocumentMetadataHelper('identityDocumentNumber', {
    defaultValue: undefined,
});
export const localPartyDocumentMetadataIssueDateSelector = selector({
    key: '@zurich/party/local/documentMetadata/issueDate',
    get: ({ get }) => {
        const document = get(localDocumentMetadataAtom);
        return document?.issueDate || undefined;
    },
    set: ({ get, set }, value) => {
        set(localDocumentMetadataAtom, {
            ...get(localDocumentMetadataAtom),
            issueDate: value instanceof DefaultValue ? undefined : value,
        });
    },
});
export const localPartyDocumentMetadataExpiryDateSelector = selector({
    key: '@zurich/party/local/documentMetadata/expiryDate',
    get: ({ get }) => {
        const document = get(localDocumentMetadataAtom);
        return document?.expiryDate || undefined;
    },
    set: ({ get, set }, value) => {
        set(localDocumentMetadataAtom, {
            ...get(localDocumentMetadataAtom),
            expiryDate: value instanceof DefaultValue ? undefined : value,
        });
    },
});
export const localPartyDocumentMetadataCountryOfIssueSelector = localPartyDocumentMetadataHelper('countryOfIssue', {
    defaultValue: undefined,
});
export const localPartyDocumentMetadataIssuingAuthoritySelector = localPartyDocumentMetadataHelper('issuingAuthority', {
    defaultValue: undefined,
});
export const localPartyDocumentMetadataDDocNumberSelector = localPartyDocumentMetadataHelper('dDocNumber', {
    defaultValue: undefined,
});
export const localPartyDocumentMetadataDDocSinceSelector = selector({
    key: '@zurich/party/local/documentMetadata/dDocSince',
    get: ({ get }) => {
        const document = get(localDocumentMetadataAtom);
        return document?.dDocSince || undefined;
    },
    set: ({ get, set }, value) => {
        set(localDocumentMetadataAtom, {
            ...get(localDocumentMetadataAtom),
            dDocSince: value instanceof DefaultValue ? undefined : value,
        });
    },
});
export const localPartyDocumentMetadataDDocUntilSelector = selector({
    key: '@zurich/party/local/documentMetadata/dDocUntil',
    get: ({ get }) => {
        const document = get(localDocumentMetadataAtom);
        return document?.dDocUntil || undefined;
    },
    set: ({ get, set }, value) => {
        set(localDocumentMetadataAtom, {
            ...get(localDocumentMetadataAtom),
            dDocUntil: value instanceof DefaultValue ? undefined : value,
        });
    },
});
export const localPartyDocumentMetadataDiplomaticStatusSelector = localPartyDocumentMetadataHelper('diplomaticStatus', {
    defaultValue: undefined,
});
